/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const SearchCode = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m9 9-2 2 2 2" }],
    ["path", { d: "m13 13 2-2-2-2" }],
    ["circle", { cx: "11", cy: "11", r: "8" }],
    ["path", { d: "m21 21-4.3-4.3" }]
  ]
];

export { SearchCode as default };
//# sourceMappingURL=search-code.js.map
